// CustomSelect.js
import React, { FC, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Select from 'react-select';
import axios from 'axios';
import clsx from 'clsx';

interface Props {
    value: number;
    onChange: (value: any) => void;
    className?: string;
    defaultOption?: any;
    initialOptions?: any[];
    disabled?: boolean;
    isClearable?: boolean;
    placeholder?: string;
}
const AttentonLevelSelect: FC<Props> = ({ value, onChange, className = '', placeholder = 'Level Atensi', disabled = false, isClearable = false, ...rest }) => {
    const options = [{
        value: 1,
        label: 'Biasa'
    }, {
        value: 2,
        label: 'Viral'
    }, {
        value: 3,
        label: 'Sangat Viral'
    }]

    const handleChange = (selectedOption) => {
        console.log(selectedOption)
        onChange(selectedOption);
    };

    return (
      <Select
        {...rest}
        name='GenderSelect'
        options={options}
        onChange={handleChange}
        value={options.find(option => option.value === value)} // Set the initial selected value
        classNamePrefix="react-select"
        className={clsx(
          'react-select',
          className,
        )}
        placeholder={placeholder}
        styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            placeholder: (base) => ({...base, color: '#99A1B7'}),
        }}
        menuPortalTarget={document.body}
        menuShouldScrollIntoView={false}
        isDisabled={disabled}
        isClearable={isClearable}
      />
    );
};

export default AttentonLevelSelect
